// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.__music_player{bottom:55px;width:100%}.__music_player .__player_box{padding:15px 0px}`, "",{"version":3,"sources":["webpack://./src/pages/MusicPlayer/index.scss"],"names":[],"mappings":"AAAA,gBACE,WAAA,CACA,UAAA,CACA,8BACE,gBAAA","sourcesContent":[".__music_player {\n  bottom: 55px;\n  width: 100%;\n  .__player_box {\n    padding: 15px 0px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
